import { render, staticRenderFns } from "./DashboardSharingTokensView.vue?vue&type=template&id=128335e2&scoped=true&"
import script from "./DashboardSharingTokensView.vue?vue&type=script&lang=js&"
export * from "./DashboardSharingTokensView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSharingTokensView.vue?vue&type=style&index=0&id=128335e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128335e2",
  null
  
)

/* custom blocks */
import block0 from "./DashboardSharingTokensView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports